var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMiclogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.00195312,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#E4EBF1"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6388_11721",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 20,
    height: 21
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6.00195,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6388_11721)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 17.2521C15.4178 17.2521 14.925 17.0504 14.5217 16.6471C14.1183 16.2438 13.9167 15.751 13.9167 15.1688V10.1688C13.9167 9.58656 14.1183 9.09378 14.5217 8.69045C14.925 8.28712 15.4178 8.08545 16 8.08545C16.5822 8.08545 17.075 8.28712 17.4783 8.69045C17.8817 9.09378 18.0833 9.58656 18.0833 10.1688V15.1688C18.0833 15.751 17.8817 16.2438 17.4783 16.6471C17.075 17.0504 16.5822 17.2521 16 17.2521ZM15.375 22.6688V20.5469C14.1346 20.4037 13.0715 19.8941 12.1858 19.0182C11.3003 18.142 10.7816 17.0742 10.6298 15.8146C10.6074 15.6373 10.6539 15.4853 10.7692 15.3588C10.8846 15.2321 11.031 15.1688 11.2083 15.1688C11.3857 15.1688 11.5342 15.23 11.6537 15.3523C11.7735 15.4745 11.8531 15.6243 11.8927 15.8017C12.0444 16.8221 12.511 17.6661 13.2925 18.3338C14.074 19.0016 14.9765 19.3354 16 19.3354C17.0373 19.3354 17.9433 18.9981 18.7179 18.3234C19.4925 17.6488 19.9556 16.8082 20.1073 15.8017C20.1469 15.6243 20.2265 15.4745 20.3462 15.3523C20.4658 15.23 20.6143 15.1688 20.7917 15.1688C20.969 15.1688 21.1154 15.2321 21.2308 15.3588C21.3461 15.4853 21.3926 15.6373 21.3702 15.8146C21.2184 17.0464 20.7032 18.106 19.8246 18.9934C18.9458 19.8806 17.8793 20.3984 16.625 20.5469V22.6688C16.625 22.8461 16.5651 22.9946 16.4454 23.1142C16.3258 23.2339 16.1773 23.2938 16 23.2938C15.8226 23.2938 15.6742 23.2339 15.5546 23.1142C15.4348 22.9946 15.375 22.8461 15.375 22.6688Z",
    fill: "#3C5F7A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiclogo);
export default __webpack_public_path__ + "static/media/Miclogo.377431adf2cca19b184abd154ae749a2.svg";
export { ForwardRef as ReactComponent };